import React from 'react';
import { Card } from 'react-bootstrap';

const ColorCard = ({ image, alt, onClick }) => {
  return (
    <div
      className="color-card"
      style={{ 
        borderRadius: '12px', 
        border: 'none', 
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)', 
        backgroundColor: '#ffffff',
        cursor: 'pointer',
        overflow: 'hidden',
        aspectRatio: '3/4',
        width: '100%',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease'
      }}
      onClick={onClick}
      onMouseEnter={(e) => {
        e.target.style.transform = 'translateY(-4px)';
        e.target.style.boxShadow = '0px 8px 20px rgba(0, 0, 0, 0.2)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'translateY(0)';
        e.target.style.boxShadow = '0px 4px 12px rgba(0, 0, 0, 0.15)';
      }}
    >
      <img 
        src={image} 
        alt={alt}
        style={{ 
          height: '100%', 
          width: '100%', 
          objectFit: 'cover',
          borderRadius: '12px',
          display: 'block'
        }} 
      />
    </div>
  );
};

export default ColorCard;